import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { KYMW7004Component } from './kymw7004.component';
import { GetFeatureRequestListService } from './api-services/get-feature-request-list.service';
import { UpdateFeatureRequestListService } from './api-services/update-feature-request-list.service';

@NgModule({
  declarations: [KYMW7004Component],
  imports: [
    CommonModule,
    FormsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  providers: [
    GetFeatureRequestListService,
    UpdateFeatureRequestListService,
  ],
})
export class KYMW7004Module { }
